import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-ct-five-two-two',
  templateUrl: './ct-five-two-two.component.html',
  styleUrls: ['./ct-five-two-two.component.scss']
})
export class CtFiveTwoTwoComponent implements OnInit {
  pdfSrc: string[] = [
    '/assets/pdf/NAAC/DVV/5.2.2_Students qualified in State_National _International level Examination_1.pdf',
    '/assets/pdf/NAAC/DVV/5.2.2_List of qualified students_3.pdf'];
  src: string;
  heading1 = false;
  heading2 = false;
  heading3 = false;
  showTable = false;
  c241Url = 'https://gnkc.ac.in/assets/pdf/NAAC/DVV/';

  result1: { title: string, link: string }[] = [
    {
      title: '2021-22_Number of students qualified in State_National_International level Examination_2',
      link: this.c241Url + '2021-22_Number of students qualified in State_National_International level Examination_2.pdf'
    },
    {
      title: '2020-21_Number of students qualified in State_National_International level Examination_2',
      link: this.c241Url + '2020-21_Number of students qualified in State_National_International level Examination_2.pdf'
    },
    {
      title: '2019-20_Number of students qualified in State_National_International level Examination_2',
      link: this.c241Url + '2019-20_Number of students qualified in State_National_International level Examination_2.pdf'
    },
    {
      title: '2018-19_Number of students qualified in State_National_International level Examination_2',
      link: this.c241Url + '2018-19_Number of students qualified in State_National_International level Examination_2.pdf'
    },
    {
      title: '2017-18_Number of students qualified in State_National_International level Examination_2',
      link: this.c241Url + '2017-18_Number of students qualified in State_National_International level Examination_2.pdf'
    }
  ]

  result: { title: string, link: string }[] = [];

  isLoading = true;
  ngOnInit(): void {
    this.changeRoute('1');
  }

  changeRoute(id: string) {
    this.isLoading = true;
    if (id === '3') {
      $(`one`).addClass('show');
      $(`two`).removeClass('show');
      $(`three`).removeClass('show');
      this.result = this.result1;
      this.heading1 = true;
      this.heading2 = false;
      this.heading3 = false;
      this.showTable = true;
    }
    if (id === '1') {
      $(`two`).addClass('show');
      $(`one`).removeClass('show');
      $(`three`).removeClass('show');
      this.heading1 = false;
      this.heading2 = true;
      this.heading3 = false;
      this.showTable = false;
      this.src = this.pdfSrc[0];
    }
    if (id === '2') {
      $(`three`).addClass('show');
      $(`one`).removeClass('show');
      $(`two`).removeClass('show');
      this.heading1 = false;
      this.heading2 = false;
      this.heading3 = true;
      this.showTable = false;
      this.src = this.pdfSrc[1];
    }
  }
  hideLoader() {
    this.isLoading = false;
  }
}
